export async function fetchProductInquiryThreads(sb, { buyerId, supplierId } = {}) {
  if (!sb || (!buyerId && !supplierId)) return [];
  let q = sb.from('product_inquiries').select('*').order('created_at', { ascending: false });
  if (supplierId) q = q.eq('supplier_id', supplierId);   // supplier's inbound inquiries
  if (buyerId) q = q.eq('buyer_id', buyerId);            // buyer's own inquiries
  const { data, error } = await q;
  if (error) { console.error('fetchProductInquiryThreads error:', error); return []; }
  return data || [];
}

export function getProductInquiryProductName(inquiry) {
  return inquiry?.product_name || inquiry?.product_name_ar || inquiry?.product_name_en || '';
}
// NOTE: getProductInquiryTemplates / getProductInquiryQuestion /
// getProductInquiryAllTranslations lived here as stubs returning [] / '' / {}.
// They backed the product page's "pick a template" inquiry card, which rendered
// a "3 templates" badge above an empty list and could never submit, because the
// template list was always empty and submit refused an empty question. The card
// is gone and with it the only caller. `product_inquiries` now has no writer on
// the buyer side — see docs/TECH_DEBT.md.
export function getProductInquiryStatusLabel(status) {
  const labels = {
    open: 'مفتوح',
    closed: 'مغلق',
    pending: 'قيد المراجعة',
    replied: 'تم الرد',
  };
  return labels[status] || status || '';
}